import styled from 'styled-components';
export const FeedbackIntro = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  margin-block-end: ${({ theme }) => theme.spacing.md}px;
`;
export const FeedbackActions = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm}px;
  margin-top: ${({ theme }) => theme.spacing.lg}px;
`;
export const FeedbackTrailingActions = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
